import api from "./api.js";

/**
 * @typedef {Object} ContactInquiryPayload
 * @property {string} name
 * @property {string} business_name
 * @property {string} email
 * @property {string} [phone]
 * @property {string[]} services
 * @property {string} message
 * @property {boolean} interested_support
 * @property {boolean} consent_marketing
 * @property {boolean} consent_ai_recording
 * @property {string} [preferred_contact]
 * @property {string} [timeline]
 * @property {string} [website] honeypot
 */

/**
 * @param {ContactInquiryPayload} payload
 * @returns {Promise<{ id: number, detail: string }>}
 */
export async function submitContactInquiry(payload) {
  const { data } = await api.post("/inquiries/", payload);
  return data;
}

/**
 * Flatten DRF validation errors for display.
 * @param {unknown} err
 * @returns {Record<string, string>}
 */
export function parseInquiryErrors(err) {
  const data = err?.response?.data;
  if (!data || typeof data !== "object") {
    return { _form: "Something went wrong. Please try again in a moment." };
  }
  if (typeof data.detail === "string") {
    return { _form: data.detail };
  }

  /** @type {Record<string, string>} */
  const out = {};
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      out[key] = value.join(" ");
    } else if (typeof value === "string") {
      out[key] = value;
    }
  }
  if (!Object.keys(out).length) {
    out._form = "Please check the form and try again.";
  }
  return out;
}
